var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3257 15.0002L22.2254 9.10051C22.3961 8.9237 22.4906 8.68688 22.4885 8.44107C22.4864 8.19526 22.3878 7.96013 22.2139 7.78631C22.0401 7.61249 21.805 7.51389 21.5592 7.51175C21.3134 7.50962 21.0765 7.60411 20.8997 7.77489L15 13.6746L9.10036 7.77489C8.92354 7.60411 8.68673 7.50962 8.44092 7.51175C8.19511 7.51389 7.95997 7.61249 7.78615 7.78631C7.61233 7.96013 7.51374 8.19526 7.5116 8.44107C7.50947 8.68688 7.60396 8.9237 7.77473 9.10051L13.6744 15.0002L7.77473 20.8999C7.68519 20.9864 7.61377 21.0898 7.56464 21.2042C7.5155 21.3186 7.48964 21.4416 7.48856 21.5661C7.48748 21.6906 7.5112 21.814 7.55834 21.9292C7.60548 22.0444 7.67509 22.1491 7.76311 22.2371C7.85114 22.3252 7.95581 22.3948 8.07103 22.4419C8.18624 22.489 8.30969 22.5128 8.43417 22.5117C8.55865 22.5106 8.68167 22.4847 8.79605 22.4356C8.91043 22.3865 9.01388 22.3151 9.10036 22.2255L15 16.3258L20.8997 22.2255C21.0765 22.3963 21.3134 22.4908 21.5592 22.4886C21.805 22.4865 22.0401 22.3879 22.2139 22.2141C22.3878 22.0403 22.4864 21.8051 22.4885 21.5593C22.4906 21.3135 22.3961 21.0767 22.2254 20.8999L16.3257 15.0002Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.71a3b46038b7a67f06a3e1275db32b78.svg";
export { ForwardRef as ReactComponent };